export type TimestampLike = {
  seconds?: number | string;
  _seconds?: number | string;
  toDate?: () => Date;
};

export function toDate(value: unknown): Date | null {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === 'object' && value !== null) {
    const timestamp = value as TimestampLike;

    if (typeof timestamp.toDate === 'function') {
      const converted = timestamp.toDate();
      return Number.isNaN(converted.getTime()) ? null : converted;
    }

    const rawSeconds = timestamp.seconds ?? timestamp._seconds;
    if (rawSeconds !== undefined) {
      const seconds = Number(rawSeconds);
      const converted = new Date(seconds * 1000);
      return Number.isNaN(converted.getTime()) ? null : converted;
    }
  }

  if (typeof value === 'number') {
    const converted = new Date(value);
    return Number.isNaN(converted.getTime()) ? null : converted;
  }

  const converted = new Date(String(value));
  return Number.isNaN(converted.getTime()) ? null : converted;
}

export function toMillis(value: unknown): number {
  return toDate(value)?.getTime() ?? 0;
}

